
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum LogEntryEventDataType {
	Text = 0,
	Date = 1,
	DateTime = 2,
	User = 3,
	Area = 4
}
export namespace LogEntryEventDataType {
	export function getKeys(): Map<LogEntryEventDataType, string> {
		return new Map([[0, 'Text'], [1, 'Date'], [2, 'DateTime'], [3, 'User'], [4, 'Area']]);
	}
}
